export const SYNC_ACTIVITIES = '@@activities/sync'

export const SET_ACTIVITIES = '@@activities/set'

export const SET_NEW_ACTIVITY = '@@activities/setNewActivity'
